/** Build environment */
export const BUILD_ENV = import.meta.env.MODE;
// export const IS_DEVELOPMENT = BUILD_ENV === 'development';
// export const IS_TEST = BUILD_ENV === 'test';
// export const IS_PRODUCTION = BUILD_ENV === 'production';
export const APP_WEB_API_URL_PROD = 'https://dashboard.easproject.com';
export const APP_WEB_API_URL_DEV = 'https://2024.easproject.com';
export const APP_WEB_API_PAY_URL_PROD = 'https://pay.easproject.com';
export const APP_WEB_API_PAY_URL_DEV = 'https://pay-dev.easproject.com';

export const IS_PRODUCTION = window.location.origin === APP_WEB_API_URL_PROD;
export const IS_DEVELOPMENT = !IS_PRODUCTION;

/** Permissions */
export const ALLOW_DEV_CONSOLE = import.meta.env.VITE_ALLOW_DEV_CONSOLE === 'true';
export const ALLOW_REDUX_DEVTOOLS_EXTENSION =
	import.meta.env.VITE_ALLOW_REDUX_DEVTOOLS_EXTENSION === 'true';
export const ALLOW_WINDOW_EXTENDS = import.meta.env.VITE_ALLOW_WINDOW_EXTENDS === 'true';

/** App */
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX;

/** API */

export const WEB_API_URL = IS_PRODUCTION ? window.location.origin : APP_WEB_API_URL_DEV;

export const WEB_API_PAY_URL =
	import.meta.env.VITE_PAY_API_URL_OVERRIDE ||
	(IS_PRODUCTION ? APP_WEB_API_PAY_URL_PROD : APP_WEB_API_PAY_URL_DEV);

export const REDIRECT_URL = window.location.origin;

export const PAGE_SIZE = 20;

export const VAT_CORRECTION_CREATION_DATE = '2025-04-03';
